import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../assets/logo2.png'
import '../styles/components/banner.css';

const Banner = () => {
    return (
        <div className='arroweb_banner'>
            <NavLink to="/">
                <img className='arroweb_logo' src={logo} alt='ArroWebDeveloppement' />
            </NavLink>
            <div className='arroweb_banner_text'>
                ArroWeb Dévéloppement, c'est l'assurance d'atteindre votre objectif
            </div>
        </div>
    );
};

export default Banner;